import type { ReactNode } from "react";

/// Text-shimmer loading effect over the textarea while the assistant
/// rewrites: stacked lines swept by the brand violet-to-pink gradient
/// (animate-assist-shimmer in globals.css), so the wait state visibly
/// belongs to the gradient sparkle button that triggered it.
/// The backdrop is fully opaque and the lines match the textarea's text
/// metrics (text-sm: 14px glyphs on a 20px line pitch, so h-3.5 + gap-1.5)
/// so the effect reads as the text itself being rewritten, not as thin
/// slivers floating over it.
export function WritingAssistShimmer(): ReactNode {
  return (
    <div
      aria-hidden
      className="absolute inset-0 flex flex-col justify-start gap-1.5 overflow-hidden rounded-md bg-background p-3"
    >
      <div className="h-3.5 w-11/12 rounded-md animate-assist-shimmer" />
      <div className="h-3.5 w-full rounded-md animate-assist-shimmer" />
      <div className="h-3.5 w-4/5 rounded-md animate-assist-shimmer" />
      <div className="h-3.5 w-full rounded-md animate-assist-shimmer" />
      <div className="h-3.5 w-3/4 rounded-md animate-assist-shimmer" />
      <div className="h-3.5 w-2/3 rounded-md animate-assist-shimmer" />
    </div>
  );
}
